import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleDetailComponent } from './vehicle-detail.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FilterListModule } from 'src/app/filterlist/filterlist.module';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartTableAddModule } from '../part/component/part-table-add/part-table-add.module';
import { PartTableAvailModule } from '../part/component/part-table-avail/part-table-avail.module';
import { AlertModule } from 'src/app/diagnostics/component/alert/alert.module';
import { VehicleConfigComponent } from '../vehicle-config/vehicle-config.component';
import { VehicleMaintenanceComponent } from '../vehicle-maintenance/vehicle-maintenance.component';
import { VehicleMaintenanceDetailModule } from '../vehicle-maintenance-detail/vehicle-maintenance-detail.module';
import { VehicleScheduleComponent } from '../vehicle-schedule/vehicle-schedule.component';
import { VehicleScheduleDetailModule } from '../vehicle-schedule-detail/vehicle-schedule-detail.module';
import { VehicleHeaderComponent } from '../vehicle-header/vehicle-header.component';
import { DynamicTableModule } from 'src/app/dynamic-table/dynamic-table.module';
import { AngularSplitModule } from 'angular-split';
import { MatBadgeModule } from '@angular/material/badge';
import { VehicleGridModule } from '../vehicle-grid/vehicle-grid.module';
import { SensorValueListModule } from '../sensor-value-list/sensor-value-list.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { ScheduleCriteriaPipe } from 'src/app/shared/pipes/scheduleCriteria';
import { AttributeListModule } from 'src/app/shared/attribute-list/attribute-list.module';
import { DvirComponent } from '../dvir/dvir.component';
import { VehicleDevicesComponent } from '../vehicle-devices/vehicle-devices.component';
import { AssetFaultComponent } from '../asset-fault/asset-fault.component';
import { IssuesModule } from 'src/app/issues/issues.module';
import { ScSensorPanelModule } from 'src/app/service-center/sensor-panel/sc-sensor-panel.module';
@NgModule({
  declarations: [
    VehicleDetailComponent,
    VehicleConfigComponent,
    VehicleMaintenanceComponent,
    VehicleScheduleComponent,
    VehicleHeaderComponent,
    DvirComponent,
    VehicleDevicesComponent],
  imports: [
    CommonModule,
    MatPaginatorModule,
    FilterListModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    PartTableAddModule,
    PartTableAvailModule,
    AlertModule,
    VehicleMaintenanceDetailModule,
    VehicleScheduleDetailModule,
    DynamicTableModule,
    AngularSplitModule,
    VehicleGridModule,
    MatBadgeModule,
    TranslateModule,
    SensorValueListModule,
    GoogleMapsModule,
    ApplicationPipesModule,
    AttributeListModule,
    AssetFaultComponent,
    IssuesModule,
    ScSensorPanelModule
  ],
  providers: [ScheduleCriteriaPipe]
})
export class VehicleDetailModule { }
